module.exports = __webpack_public_path__ + "static/daniel-769745b9fbe501679d1e32367f744e3a.png";